

































































































import { Component, Watch, Vue, Prop } from "vue-property-decorator";
import { preferred_language } from "@/config/languags.config.json";
import { VueEditor } from "vue2-editor";
import { ILocale } from "@/@types/locale";
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";

import SubmitResetButtonGroop from "@/components/buttons/submit-reset-button-groop.vue";
import LanguagesButtons from "@/components/buttons/languages-buttons.vue";
import StandartModal from "@/components/app/standart-modal.vue";
import { IReviews } from "@/@types/filoxenia-config/tv-config";

@Component({
  components: {
    StandartModal,
    submit: SubmitResetButtonGroop,
    LanguagesButtons,
    VueEditor,
  },
  mixins: [validationMixin],
  validations: {
    name: { required },
    description: { maxLength: maxLength(350) },
    href: { required },
  },
})
export default class ReviewsConfigSettings extends Vue {
  @Prop({ type: Object, default: null }) item!: IReviews;
  locale = preferred_language;
  name = "";
  names: ILocale = {};
  description = "";
  descriptions: ILocale = {};
  href = "";

  get reviews(): IReviews {
    return {
      name: this.names,
      description: this.descriptions,
      href: this.href,
    };
  }

  @Watch("name")
  entryFilmName(): void {
    this.names[this.locale] = this.name;
  }

  @Watch("description")
  entrydescription(): void {
    this.descriptions[this.locale] = this.description;
  }

  @Watch("locale")
  localeCreater(): void {
    if (this.names)
      this.name = this.names[this.locale] ? this.names[this.locale] : "";
    else this.name = "";
    if (this.descriptions)
      this.description = this.descriptions[this.locale]
        ? this.descriptions[this.locale]
        : "";
    else this.description = "";
  }

  @Watch("item")
  start(): void {
    this.$nextTick(() => {
      if (!this.item) return;
      this.names = this.item.name;
      this.descriptions = this.item.description;
      this.href = this.item.href;
      this.localeCreater();
    });
  }

  onSubmit(event: HTMLFormElement): void {
    event.preventDefault();
    if (this.$v.$invalid) {
      console.log("invalid");
      this.$v.$touch();
      return;
    }
    this.$emit("send", { reviews: this.reviews });
    this.$nextTick(() => this.$bvModal.hide("reviews-config-settings"));
  }

  onReset(): void {
    this.name = "";
    this.names = {};
    this.description = "";
    this.descriptions = {};
    this.href = "";
  }
}
